<!-- 由 suu 创建于 2022-01-19 星期三 -->
<template>
  <div class="fback-radio">
    <div class="text">{{ data.field_title }}</div>
    <div class="list">
      <div
        :class="['item', active === index ? 'item-active' : '']"
        v-for="(item, index) in data.field_unit"
        :key="index"
        @click="bindChange(item, index)"
      >
        <div>{{ item.value }}</div>
        <van-icon v-if="active === index" color="#6384e8" name="success" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fback-radio',

  components: {},

  props: {
    data: {},
    index: {}
  },

  data() {
    return {
      active: ''
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    bindChange(item, index) {
      let key = item.key
      this.active = index
      this.$emit('change', {
        value: key,
        index: this.index
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.fback-radio {
  margin-bottom: vw(40);
  .text {
    margin-bottom: vw(22);
  }
  .list {
    font-size: vw(30);
    color: #000;
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: vw(22) vw(50);
    box-sizing: border-box;
    height: vw(80);
    background-color: #fff;
    border-radius: vw(12);
    border: solid vw(2) #f1f1f1;
    font-size: vw(26);
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: vw(16);
  }
  .list .item:last-child {
    margin-bottom: vw(0);
  }
  .item-active {
    color: #6384e8;
  }
}
</style>
